export class FilePreviewBuilder {
  constructor(file, previewTarget) {
    this.file = file
    this.previewTarget = previewTarget
    this.previewItem = this.createPreviewItem()
  }

  build() {
    if (this.file.type.startsWith('image/')) {
      this.buildImagePreview()
    } else if (this.file.type.startsWith('video/')) {
      this.buildVideoPreview()
    } else if (this.file.type.startsWith('audio/')) {
      this.buildAudioPreview()
    }

    return this.previewItem
  }

  createPreviewItem() {
    const previewItem = document.createElement('div')
    previewItem.className = 'file-preview-item'
    previewItem.dataset.fileName = this.file.name
    return previewItem
  }

  buildImagePreview() {
    this.showLoadingState()
    this.previewTarget.appendChild(this.previewItem)

    const reader = new FileReader()
    reader.onprogress = (e) => this.updateProgress(e)
    reader.onload = (e) => this.loadImageThumbnail(e)
    reader.onerror = () => this.showReadError()
    reader.readAsDataURL(this.file)
  }

  showLoadingState() {
    const loadingSpinner = '<div class="loading-spinner"></div>'
    const progressInfo = '<p class="file-type">Loading... <span class="progress-percent">0%</span></p>'
    this.previewItem.innerHTML = buildPreviewHTML(this.file, loadingSpinner, progressInfo)
  }

  updateProgress(event) {
    if (event.lengthComputable) {
      const percentLoaded = Math.round((event.loaded / event.total) * 100)
      const progressSpan = this.previewItem.querySelector('.progress-percent')
      if (progressSpan) {
        progressSpan.textContent = `${percentLoaded}%`
      }
    }
  }

  loadImageThumbnail(event) {
    const img = new Image()
    img.onload = () => this.showImagePreview(img)
    img.onerror = () => this.showImageLoadError()
    img.src = event.target.result
  }

  showImagePreview(img) {
    const thumbnail = createImageThumbnail(img, 80, 80)
    const extraInfo = `
      <p class="file-dimensions">${img.width} × ${img.height} pixels</p>
      <label class="keep-original-label">
        <input type="checkbox" class="keep-original-checkbox">
        Keep original
      </label>
    `
    this.previewItem.innerHTML = buildPreviewHTML(this.file, `<img src="${thumbnail}" alt="${this.file.name}">`, extraInfo)
  }

  showImageLoadError() {
    const errorInfo = '<p class="file-type text-danger">Failed to load image preview</p>'
    this.previewItem.innerHTML = buildPreviewHTML(this.file, '<i class="glyphicon glyphicon-picture text-warning"></i>', errorInfo)
  }

  showReadError() {
    const errorInfo = '<p class="file-type text-danger">Failed to read file</p>'
    this.previewItem.innerHTML = buildPreviewHTML(this.file, '<i class="glyphicon glyphicon-warning-sign text-danger"></i>', errorInfo)
  }

  buildVideoPreview() {
    const extraInfo = '<p class="file-type">Video</p>'
    this.previewItem.innerHTML = buildPreviewHTML(this.file, '<i class="glyphicon glyphicon-film"></i>', extraInfo)
    this.previewTarget.appendChild(this.previewItem)
  }

  buildAudioPreview() {
    const extraInfo = '<p class="file-type">Audio</p>'
    this.previewItem.innerHTML = buildPreviewHTML(this.file, '<i class="glyphicon glyphicon-headphones"></i>', extraInfo)
    this.previewTarget.appendChild(this.previewItem)
  }
}

export function createImageThumbnail(img, maxWidth, maxHeight) {
  let width = img.width
  let height = img.height

  if (width > maxWidth || height > maxHeight) {
    const ratio = Math.min(maxWidth / width, maxHeight / height)
    width = Math.floor(width * ratio)
    height = Math.floor(height * ratio)
  }

  const canvas = document.createElement('canvas')
  canvas.width = width
  canvas.height = height
  const ctx = canvas.getContext('2d')
  ctx.drawImage(img, 0, 0, width, height)

  return canvas.toDataURL('image/jpeg', 0.8)
}

export function buildPreviewHTML(file, thumbnailContent, extraInfo = '') {
  return `
    <div class="preview-thumbnail">
      ${thumbnailContent}
    </div>
    <div class="preview-info">
      <p class="file-name">${file.name}</p>
      <p class="file-size">${formatFileSize(file.size)}</p>
      ${extraInfo}
    </div>
    <button type="button" class="btn btn-sm btn-danger remove-file" data-action="click->media-upload#removeFile">
      Remove
    </button>
  `
}

export function formatFileSize(bytes) {
  if (bytes === 0) return '0 Bytes'
  const k = 1024
  const sizes = ['Bytes', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i]
}